<script>
import lazyLoadComponent from '@router/lazyload-component'
import { cloneDeep } from 'lodash'
import { currentQuestionList } from '@utils/pet-question'
import formatDate from '@utils/format-date'
import petQ from '@src/mixins/petQ'

const mixinMapArrFunc = (alias) => {
  const { defaultFormMapping, glowFormMapping } = petQ.data()
  const arr = alias === 'glow-headspa' ? glowFormMapping : defaultFormMapping

  return arr.reduce((acc, cur) => {
    acc[cur] = []
    return acc
  }, {})
}
const initData = (alias) => {
  return {
    categoryId: '',
    sizeId: '',
    name: '',
    birthday: '',
    avatar: '',
    gender: '',
    breed: '',
    note: '',
    memberId: '',
    questions: {
      personality: [],
      vaccine: 0,
      ...mixinMapArrFunc(alias),
    },
  }
}
export default {
  components: {
    BaseUpload: () => lazyLoadComponent(import('@components/BaseUpload')),
    PetCommentList: () => lazyLoadComponent(import('@components/PetCommentList')),
    Note: () => lazyLoadComponent(import('@components/Note')),
  },
  mixins: [petQ],
  props: {
    defaultValue: {
      type: Object,
      default: () => {},
    },
    activeId: {
      type: [Number, String],
      default: '',
    },
    memberInfo: {
      type: Object,
      required: true,
    },
    petInfoActiveTab: {
      type: String,
      default: 'information',
      validator(value) {
        return ['information', 'history', 'service', 'currentService'].includes(value)
      },
    },
    isShowPetList: {
      type: Boolean,
      default: false,
    },
    // 判斷是否只是美容師
    isEmployee: {
      type: Boolean,
      default: false,
    },
    alias: {
      type: String,
      required: true,
    },
    showHeaderTabs: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      category: [],
      questions: cloneDeep(currentQuestionList(this.alias)),
      submitData: Object.assign({}, initData(this.alias)),
      petDetailInfo: {},
      petList: [],
      editPetEnabled: false,
      tryingGetPet: false,
      petEditMode: 'edit',
      parentCategoryIndex: 0,
      behavior: [],
      healthy: [],

      showDetailPet: false,
      petTabType: 'info',
      tryingSavePet: false,
      editPetComment: false,
      petActiveTab: this.petInfoActiveTab || 'information',
      petCommentData: {}, // 為了從 note的 data 傳到 另外一個 note 的 data
      dialogVisible: false,
      dialogImageUrl: '',
      inVueQItems: [],
    }
  },
  computed: {
    petListImg() {
      if (this.$appType() === 'ipetbooking') {
        return require('@assets/images/staff_avatar_haku.png')
      }
      if (this.$appType() === 'dingbeauty') {
        return require('@assets/images/person_background.svg')
      }
      return require('@assets/images/staff_avatar_haku.png')
    },
    submitRules() {
      return {
        avatar: [
          {
            required: true,
            message: '請上傳頭像',
            trigger: 'change',
          },
        ],
        name: [
          {
            required: true,
            message: `請填寫${this.$t('reserve.CLIENT')}名`,
            trigger: 'blur',
          },
        ],
        categoryId: [
          {
            required: true,
            message: '請選擇類別',
            trigger: 'blur',
          },
        ],
        sizeId: [
          {
            required: true,
            message: `請選擇${this.$t('member.BODY_TO_TYPE')}`,
            trigger: 'blur',
          },
        ],
        gender: [
          {
            required: true,
            message: '請選擇性別',
            trigger: 'change',
          },
        ],
        birthday: [
          {
            required: true,
            message: '請選擇生日',
            trigger: 'blur',
            // trigger: 'change',
          },
        ],
      }
    },
    categorySizeList() {
      const sizeList = this.category.find(({ id }) => this.submitData.categoryId === id)
      return sizeList ? sizeList.children : []
    },
    personalityContent() {
      return this.petDetailInfo?.questions?.personality.join('，')
    },
    healthyContent() {
      const content = this.petDetailInfo?.questions?.healthy.map((item) => {
        return `${item.title}${item.text ? ` ( ${item.text} ) ` : ''}`
      })
      return content.join('，')
    },
    behaviorContent() {
      const content = this.petDetailInfo?.questions?.behavior.map((item) => {
        return `${item.title}${item.text ? ` ( ${item.text} ) ` : ''}`
      })
      return content
    },
    vaccineContent() {
      let vaccine = '無'
      switch (this.petDetailInfo?.questions?.vaccine) {
        case 1:
          vaccine = '1 劑'
          break
        case 2:
          vaccine = '2 劑'
          break
        case 3:
          vaccine = '3 劑'
          break
        default:
          break
      }
      return vaccine
    },
  },
  watch: {
    petDetailInfo(val) {
      this.inVueQItems.forEach((item) => this.clearText(item))
      if (val.questions) {
        this.targetMappingArray.forEach((item) => {
          this[item] = val.questions[item].map((item) => item.title)
        })
      } else {
        this.targetMappingArray.forEach((item) => {
          this[item] = []
        })
      }
    },
    petInfoActiveTab: {
      immediate: true,
      handler(val, oldVal) {
        this.petActiveTab = val
        if (this.activeId) {
          this.tryToFetchSinglePet(this.activeId)
        }
      },
    },
  },
  async mounted() {
    this.inVueQItems = JSON.parse(JSON.stringify(this.targetMappingArray))
  },
  async created() {
    this.initWatch()
    await this.tryToFetchPetList()
    await this.tryToFetchCategory()
  },
  methods: {
    /**
     * @description watch監控每一個問題
     */
    initWatch() {
      try {
        this.targetMappingArray.forEach((property) => {
          this.$watch(property, (value) => {
            this.updateSelectedQuestions(value, property)
          })
        })
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 同會員資料
     */
    sameMemberInfo() {
      try {
        this.$set(this.submitData, 'gender', this.memberInfo.gender)
        this.$set(this.submitData, 'name', this.memberInfo.fullName)
        if (this.memberInfo.extraInfos && this.memberInfo.extraInfos.birthday) {
          this.$set(this.submitData, 'birthday', this.memberInfo.extraInfos.birthday)
        }
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 組成顯示的問題格式
     */
    personalityContentMethods(key) {
      try {
        let textValue = []
        if (Object.keys(this.petDetailInfo).length > 0 && key in this.petDetailInfo.questions) {
          textValue = this.petDetailInfo.questions[key].map((item) => {
            let oriText = `${item.title}${item.text ? ' ( ' : ''} ${item.text ? item.text : ''}${item.text ? ' )' : ''}`
            if (item.name === 'pregnant') {
              return `${oriText} 週`
            } else {
              return `${oriText}`
            }
          })
        }
        return textValue.length > 0 ? textValue.join('，') : '未填寫'
      } catch (error) {
        console.error(error.message)
      }
    },
    clearText(key) {
      this.questions[key].forEach((item) => {
        item.text = ''
      })
    },
    formatDate,
    async tryToFetchCategory() {
      this.category = await this.$store.dispatch('product/fetchServiceCategory', { paginate: 0 })
    },
    async tryToFetchPetList() {
      this.petList = await this.$store.dispatch('member/fetchPetList', {
        memberId: this.memberInfo.id,
      })
    },
    /**
     * @description 新增寵物
     */
    async tryToSavePet() {
      await this.$refs.form.validate()
      const updateSubmitDataQuestions = () => {
        if (this.submitData.questions) {
          this.inVueQItems.forEach((qItem) => {
            this.submitData.questions[qItem].forEach((item) => {
              this.questions[qItem].forEach((i) => {
                if (item.title === i.title) {
                  item.text = i.text
                }
              })
            })
          })
        }
      }

      updateSubmitDataQuestions()
      try {
        this.tryingSavePet = true

        if (this.petEditMode === 'new') {
          await this.$store.dispatch('member/storeSinglePet', this.submitData)
          this.showDetailPet = false
          this.tryToFetchPetList()
        } else {
          await this.$store.dispatch('member/storeSinglePet', this.submitData)
          this.tryToFetchSinglePet(this.petDetailInfo.id)
        }

        this.editPetEnabled = false
        // 更新會員資訊，否則 this.memberInfo.pets 可能是空的
        this.$emit('update')
      } finally {
        this.tryingSavePet = false
      }
    },
    async showPetDetail(item) {
      await this.tryToFetchSinglePet(item.id)
      this.showDetailPet = true
    },
    /**
     * @description 找尋寵物單筆資料
     */
    async tryToFetchSinglePet(petId) {
      try {
        this.tryingGetPet = true
        const { items } = await this.$store.dispatch('member/fetchSinglePet', {
          memberId: this.memberInfo.id,
          petId,
        })
        this.targetMappingArray.forEach((mapItem) => {
          if (!items['questions'].hasOwnProperty(mapItem)) {
            this.$set(items['questions'], mapItem, [])
          }
        })
        this.petDetailInfo = items
      } finally {
        this.tryingGetPet = false
      }
    },
    async petUploadToStore() {
      await this.$store.dispatch('member/storeSinglePet', {
        id: this.petDetailInfo.id,
        memberId: this.petDetailInfo.memberId,
        avatar: this.petDetailInfo.avatar,
        sizeId: this.petDetailInfo.sizeId,
        name: this.petDetailInfo.name,
      })
    },
    onClickClose() {
      this.$emit('close')
      this.closeEditPet()
    },
    closeEditPetComment() {
      this.editPetComment = false
    },
    closeEditPet() {
      this.editPetEnabled = false
    },
    onChangeCategory() {
      this.submitData.sizeId = ''
    },
    onSelectPetTabType(type) {
      this.petTabType = type
    },
    onCommentLoadingChange(isLoading) {
      this.$emit('loading-change', isLoading)
    },
    createPet() {
      this.editPetEnabled = true
      this.petEditMode = 'new'
      this.submitData = Object.assign({}, initData(this.targetMappingArray))
      this.submitData.memberId = this.memberInfo.id
      this.getDefaultCategory()
      this.behavior = []
      this.healthy = []
      this.questions.behavior.forEach((item) => {
        item.text = ''
      })
      this.questions.healthy.forEach((item) => {
        item.text = ''
      })
    },
    openEditPet() {
      try {
        this.editPetEnabled = true
        this.petEditMode = 'edit'
        this.submitData = {
          ...this.petDetailInfo,
        }
        this.targetMappingArray.forEach((qItem) => {
          this.submitData.questions[qItem].forEach((item) => {
            this.questions[qItem].forEach((i) => {
              if (item.title === i.title) {
                i.text = item.text
              }
            })
          })
        })
      } catch (error) {
        console.error(error.message)
      }
    },
    backToPetList() {
      this.showDetailPet = false
      this.closeEditPet()
      this.closeEditPetComment()
      this.petDetailInfo = {}
      this.tryToFetchPetList()
    },
    selectPet({ id }) {
      this.$emit('selected', id)
    },
    /**
     * @description update問題
     */
    updateSelectedQuestions(value, keyName) {
      if (!this.inVueQItems.includes(keyName)) {
        throw new Error(`keyName: "${keyName}" doesn't exist`)
      }

      if (value.length === 0) {
        this.submitData.questions[keyName] = []
        return
      }

      this.submitData.questions[keyName] = value.map((item) => {
        return this.questions[keyName].find((i) => i.title === item)
      })
    },
    closeInsideEdit() {
      this.closeEditPet()
      this.closeEditPetComment()
    },
    isEditPetComment(val) {
      if (!val) {
        this.closeInsideEdit()
      } else {
        this.editPetComment = val
      }
    },
    setPetCommentData(val) {
      this.petCommentData = { ...val }
    },
    updatePetList() {
      this.tryToFetchSinglePet(this.activeId)
    },
    handlePreview(file) {
      this.dialogImageUrl = file
      this.dialogVisible = true
    },
    getDefaultCategory() {
      this.submitData.categoryId = this.category[0].id
      this.submitData.sizeId = this.category[0].children[0].id
    },
  },
}
</script>
<template>
  <div :class="$style.orderformSection">
    <template v-if="editPetEnabled">
      <div class="orderformSection__right__header">
        <button class="el-drawer__close-btn" aria-label="close drawer" type="button" @click="closeInsideEdit"><i class="el-dialog__close el-icon el-icon-close"></i></button>
        <h4 class="orderformSection__right__title">編輯{{ $t('reserve.CLIENT') }}</h4>
      </div>
      <div class="orderformSection__right__content">
        <el-button class="is-round is-fullwidth" type="primary" style="margin-bottom: 20px" @click="sameMemberInfo">同會員資料</el-button>
        <el-form ref="form" :model="submitData" :rules="submitRules" label-position="left" class="el-form-item--normal-margin el-form-item--white-bg isStylePetList" :validate-on-rule-change="false">
          <el-form-item class="isAvatar">
            <h6 class="text-cener">{{ petEditMode === 'new' ? `新增${$t('reserve.CLIENT')}資料` : `編輯${$t('reserve.CLIENT')}資料` }}</h6>
            <BaseUpload v-model="submitData.avatar" v-loading="tryingGetPet" resource="pet" circle dir="pet" />
          </el-form-item>
          <el-form-item prop="name" :label="`${$t('reserve.CLIENT')}名`" class="el-form-item--normal-margin">
            <el-input v-model="submitData.name" :placeholder="`請輸入${$t('reserve.CLIENT')}名`"></el-input>
          </el-form-item>
          <el-form-item label="類別" prop="categoryId" class="el-form-item--normal-margin">
            <el-select v-model="submitData.categoryId" @change="onChangeCategory">
              <el-option v-for="(item, index) in category" :key="index" :value="item.id" :label="item.title"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="`${$t('member.BODY_TO_TYPE')}`" prop="sizeId" class="el-form-item--normal-margin">
            <el-select v-model="submitData.sizeId" :placeholder="!!submitData.categoryId ? '請選擇' : '請先選擇類別'">
              <el-option v-for="(item, index) in categorySizeList" :key="index" :label="item.title" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="$merchantI18n() === 'pet'" prop="breed" label="品種" class="el-form-item--normal-margin">
            <el-input v-model="submitData.breed" placeholder="請輸入品種"></el-input>
          </el-form-item>
          <el-form-item label="性別" class="el-form-item--normal-margin">
            <el-select v-model="submitData.gender">
              <el-option :label="`${$t('sex.Female')}`" value="female"></el-option>
              <el-option :label="`${$t('sex.Male')}`" value="male"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="生日" class="el-form-item--normal-margin">
            <el-date-picker v-model="submitData.birthday" type="date" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <!-- 寵物問題編輯模式 -->
          <template v-if="$merchantI18n() === 'pet'">
            <el-form-item label="個性" class="el-form-item--normal-margin">
              <el-checkbox-group v-model="submitData.questions.personality">
                <template v-for="item in questions.personality">
                  <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                  <el-input v-if="submitData.questions.personality.includes('其他') && item.name === 'other'" :key="item.title" v-model="item.text" placeholder="請填寫" />
                </template>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="寵物病史" class="el-form-item--normal-margin">
              <span>飼主應盡告知義務，若因隱瞞病況發生意外或死亡，經法定程序判定店家無疏失，店家不須負損害賠償責任</span>
              <el-checkbox-group v-model="healthy">
                <template v-for="item in questions.healthy">
                  <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                  <el-input v-if="healthy.includes('其他') && item.name === 'other'" :key="item.title" v-model="item.text" placeholder="請填寫其他疾病" />
                </template>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="行為" class="el-form-item--normal-margin">
              <el-checkbox-group v-model="behavior">
                <template v-for="item in questions.behavior">
                  <div :key="item.title" class="inline-checkbox-input">
                    <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                    <el-input v-model="item.text" />
                  </div>
                </template>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="疫苗" class="el-form-item--normal-margin no-bg-radio-group">
              <el-radio-group v-model="submitData.questions.vaccine">
                <el-radio :label="0">無</el-radio>
                <el-radio :label="1">1 劑</el-radio>
                <el-radio :label="2">2 劑</el-radio>
                <el-radio :label="3">3 劑</el-radio>
              </el-radio-group>
            </el-form-item>
          </template>
          <!-- 使用人問題編輯模式 -->
          <template v-if="$merchantI18n() === 'beauty'">
            <el-divider></el-divider>
            <h5 class="mb-3 fw-regular">身體狀況</h5>
            <el-form-item label="備孕/懷孕" class="el-form-item--normal-margin">
              <el-checkbox-group v-model="pregnant">
                <template v-for="item in questions.pregnant">
                  <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                  <el-input v-if="pregnant.includes('懷孕中') && item.name === 'pregnant'" :key="item.title" v-model="item.text" placeholder="請填寫週數" />
                </template>
              </el-checkbox-group>
            </el-form-item>

            <el-form-item label="生活狀況" class="el-form-item--normal-margin">
              <el-checkbox-group v-model="livinCondition">
                <template v-for="item in questions.livinCondition">
                  <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                  <el-input v-if="livinCondition.includes('藥物') && item.name === 'drug'" :key="item.title" v-model="item.text" placeholder="請填寫藥物" />
                </template>
              </el-checkbox-group>
            </el-form-item>

            <el-form-item label="健康狀態" class="el-form-item--normal-margin">
              <el-checkbox-group v-model="healthStatus">
                <template v-for="item in questions.healthStatus">
                  <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                  <el-input v-if="healthStatus.includes('其他') && item.name === 'other'" :key="item.title" v-model="item.text" placeholder="請填寫健康狀態" />
                </template>
              </el-checkbox-group>
            </el-form-item>

            <el-form-item label="肌膚狀態" class="el-form-item--normal-margin">
              <el-checkbox-group v-model="skinCondition">
                <template v-for="item in questions.skinCondition">
                  <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                  <el-input v-if="skinCondition.includes('其他肌膚問題') && item.name === 'other'" :key="item.title" v-model="item.text" placeholder="請填寫肌膚狀態" />
                </template>
              </el-checkbox-group>
            </el-form-item>
            <el-divider></el-divider>
            <h5 class="mb-3 fw-regular">肌膚狀況</h5>
            <el-form-item label="有無開刀史" class="el-form-item--normal-margin">
              <el-checkbox-group v-model="historyOfSurgery">
                <template v-for="item in questions.historyOfSurgery">
                  <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                  <el-input v-if="historyOfSurgery.includes('有') && item.name === 'yes'" :key="item.title" v-model="item.text" placeholder="請填寫部位" />
                </template>
              </el-checkbox-group>
            </el-form-item>

            <el-form-item label="膚質" class="el-form-item--normal-margin">
              <el-checkbox-group v-model="skinType">
                <template v-for="item in questions.skinType">
                  <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                </template>
              </el-checkbox-group>
            </el-form-item>

            <el-form-item label="防曬狀況" class="el-form-item--normal-margin">
              <el-checkbox-group v-model="sunProtectionStatus">
                <template v-for="item in questions.sunProtectionStatus">
                  <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                </template>
              </el-checkbox-group>
            </el-form-item>

            <el-form-item label="防曬習慣" class="el-form-item--normal-margin">
              <el-checkbox-group v-model="sunProtectionHabits">
                <template v-for="item in questions.sunProtectionHabits">
                  <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                  <el-input v-if="sunProtectionHabits.includes('備註') && item.name === 'remark'" :key="item.title" v-model="item.text" placeholder="請填寫備註" />
                </template>
              </el-checkbox-group>
            </el-form-item>

            <el-form-item label="卸妝產品類型" class="el-form-item--normal-margin">
              <el-checkbox-group v-model="makeupRemoverType">
                <template v-for="item in questions.makeupRemoverType">
                  <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                  <el-input v-if="makeupRemoverType.includes('備註') && item.name === 'remark'" :key="item.title" v-model="item.text" placeholder="請填寫備註" />
                </template>
              </el-checkbox-group>
            </el-form-item>

            <el-form-item label="使用的保養品" class="el-form-item--normal-margin">
              <el-checkbox-group v-model="skinCareProductsUsed">
                <template v-for="item in questions.skinCareProductsUsed">
                  <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                  <el-input v-if="skinCareProductsUsed.includes('備註') && item.name === 'remark'" :key="item.title" v-model="item.text" placeholder="請填寫備註" />
                </template>
              </el-checkbox-group>
            </el-form-item>

            <el-form-item label="近期醫美療程" class="el-form-item--normal-margin">
              <el-checkbox-group v-model="recentMedicalTreatment">
                <template v-for="item in questions.recentMedicalTreatment">
                  <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                  <el-input v-if="recentMedicalTreatment.includes('療程名稱') && item.name === 'name'" :key="item.title" v-model="item.text" placeholder="請填寫療程名稱" />
                  <el-input v-if="recentMedicalTreatment.includes('日期') && item.name === 'date'" :key="item.title" v-model="item.text" placeholder="請填寫日期" />
                </template>
              </el-checkbox-group>
            </el-form-item>

            <el-form-item label="希望解決的肌膚問題" class="el-form-item--normal-margin">
              <el-checkbox-group v-model="skinProblemYouWantToSolve">
                <template v-for="item in questions.skinProblemYouWantToSolve">
                  <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                  <el-input v-if="skinProblemYouWantToSolve.includes('備註') && item.name === 'remark'" :key="item.title" v-model="item.text" placeholder="請填寫備註" />
                </template>
              </el-checkbox-group>
            </el-form-item>
          </template>
          <div class="btn-group-inline isStylePetList" style="padding: 30px 0 50px">
            <el-button plain class="is-round" @click="closeEditPet">取消</el-button>
            <el-button :loading="tryingSavePet" class="is-round" type="primary" @click="tryToSavePet">儲存</el-button>
          </div>
        </el-form>
      </div>
    </template>
    <!-- 編輯新增寵物備註 -->
    <template v-if="editPetComment">
      <div class="orderformSection__right__header">
        <button class="el-drawer__close-btn" aria-label="close drawer" type="button" @click="closeInsideEdit"><i class="el-dialog__close el-icon el-icon-close"></i></button>
        <h4 class="orderformSection__right__title">{{ $t('member.PET_TO_SKIN') }}備註</h4>
      </div>
      <div class="orderformSection__right__content">
        <Note ref="note" :default-value="petDetailInfo" type="pet" is-can-add is-order is-edit-status :single-value="petCommentData" @edit="isEditPetComment" @update="updatePetList"></Note>
      </div>
    </template>
    <template v-if="!editPetEnabled && !editPetComment">
      <template v-if="!showDetailPet && isShowPetList">
        <!-- 選擇寵物list -->
        <div class="orderformSection__right__header">
          <button class="el-drawer__close-btn" aria-label="close drawer" type="button" @click="onClickClose"><i class="el-dialog__close el-icon el-icon-close"></i></button>
          <h4 class="orderformSection__right__title">選擇{{ $t('reserve.CLIENT') }}</h4>
        </div>
        <div class="orderformSection__right__content">
          <el-button class="is-round is-fullwidth" type="primary" style="margin-bottom: 20px" @click="createPet"> <BaseIcon name="plus" /> 新增{{ $t('reserve.CLIENT') }} </el-button>
          <div v-for="item in petList" :key="item.id" :class="[$style.petList, { isActive: activeId === item.id }]" @click="selectPet(item)">
            <img v-if="item.avatar" class="petList__img" :src="item.avatar" alt="" />
            <img v-else class="petList__img" :src="petListImg" alt="" />
            <div class="petList__cont">
              <div style="padding-bottom: 10px d-flex align-items-center">
                {{ item.name }}
                <el-button class="isPrimary" type="text" size="mini" @click.stop="showPetDetail(item)">
                  <BaseIcon name="eye" class="fs-xl" />
                </el-button>
              </div>
              {{ item.breed }}
              {{ item.categoryTitle }}
              {{ item.sizeTitle }}
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div v-if="showHeaderTabs" class="orderformSection__right__header">
          <button v-if="isShowPetList" class="el-drawer__close-btn" aria-label="close drawer" type="button" @click="backToPetList"><i class="el-dialog__close el-icon el-icon-close"></i></button>
          <button v-else class="el-drawer__close-btn" aria-label="close drawer" type="button" @click="onClickClose"><i class="el-dialog__close el-icon el-icon-close"></i></button>

          <el-tabs v-model="petActiveTab" stretch class="isStyleBaseTab">
            <el-tab-pane :label="`${$t('reserve.CLIENT')}資訊`" name="information"> </el-tab-pane>
            <el-tab-pane label="歷史紀錄" name="service"> </el-tab-pane>
            <el-tab-pane v-if="defaultValue && defaultValue.id" label="服務紀錄" name="currentService"> </el-tab-pane>
          </el-tabs>
        </div>
        <div class="orderformSection__right__content">
          <!-- 寵物詳細資料 -->
          <template>
            <el-button v-if="isShowPetList" class="is-round is-fullwidth" style="margin-bottom: 20px" @click="backToPetList">返回{{ $t('reserve.CLIENT') }}列表</el-button>
            <div v-if="petActiveTab === 'information'" :class="$style.pet">
              <div v-loading="tryingGetPet" class="pet__box" element-loading-background="rgba(0, 0, 0, 0)">
                <el-row :gutter="20" style="margin-bottom: 30px">
                  <el-col :span="24">
                    <div class="pet__avatar text-center" style="margin-bottom: 20px">
                      <BaseUpload v-if="!isEmployee" v-model="petDetailInfo.avatar" resource="pet" circle dir="pet" @sendSuccess="petUploadToStore" />
                      <template v-else>
                        <img v-if="petDetailInfo.avatar" :src="petDetailInfo.avatar" alt="" class="el-upload__img" @click="handlePreview(petDetailInfo.avatar)" />
                        <div v-else :style="{ backgroundImage: `url('${require('@assets/images/pet-avatar-default@2x.png')}')` }" class="el-upload__img"></div>
                      </template>
                    </div>
                  </el-col>
                  <el-col :span="24">
                    <h5 class="form-block-title fw-regular">
                      {{ $t('reserve.CLIENT') }}資料
                      <el-button v-if="!isEmployee" type="text" size="mini" :disabled="tryingGetPet" @click="openEditPet">
                        <BaseIcon name="edit" class="text-primary fs-xl align-text-top" />
                        <span>編輯資訊</span>
                      </el-button>
                    </h5>
                  </el-col>
                  <!-- 寵物問題 觀看模式 -->
                  <el-col :span="24">
                    <div class="pet__info">
                      <ul class="pet__info__list">
                        <li class="pet__info__item"
                          >{{ $t('reserve.CLIENT') }}名：<span class="text-secondary">{{ petDetailInfo.name }}</span></li
                        >
                        <li class="pet__info__item"
                          >類別：<span class="text-secondary">{{ petDetailInfo.categoryTitle }}</span></li
                        >
                        <li class="pet__info__item"
                          >{{ $t('member.BODY_TO_TYPE') }}：<span class="text-secondary">{{ petDetailInfo.sizeTitle }}</span></li
                        >
                        <li v-if="$merchantI18n() === 'pet'" class="pet__info__item"
                          >品種：<span class="text-secondary">{{ petDetailInfo.breed }}</span></li
                        >
                        <li class="pet__info__item">
                          性別：
                          <span v-if="petDetailInfo.gender" class="text-secondary">
                            {{ petDetailInfo.gender === 'male' ? `${$t('sex.Male')}` : `${$t('sex.Female')}` }}
                          </span>
                        </li>
                        <li class="pet__info__item"
                          >生日：<span class="text-secondary">{{ petDetailInfo.birthday }}</span>
                        </li>
                      </ul>
                    </div>
                  </el-col>
                  <!-- 使用人問題 觀看模式 -->
                  <el-col v-if="$merchantI18n() === 'beauty'" :span="24" class="client">
                    <el-divider></el-divider>
                    <h5 class="mb-3 fw-regular">身體狀況</h5>
                    <div class="pet__info">
                      <ul class="pet__info__list">
                        <li v-for="item in bodyConditionForBeauty" :key="item.key" :md="12" :span="24" class="pet__info__item">
                          {{ item.text }}：<span class="Jost" style="color: #121931">{{ personalityContentMethods(item.key) }}</span>
                        </li>
                      </ul>
                    </div>
                    <el-divider></el-divider>
                    <h5 class="mb-3 fw-regular">肌膚狀況</h5>
                    <div class="pet__info">
                      <ul class="pet__info__list">
                        <li :md="12" :span="24" class="pet__info__item">
                          膚質：<span class="Jost" style="color: #121931">{{ personalityContentMethods('skinType') }}</span>
                        </li>
                        <li :md="12" :span="24" class="pet__info__item">
                          防曬狀況：<span class="Jost" style="color: #121931">{{ personalityContentMethods('sunProtectionStatus') }}</span>
                        </li>
                        <li :md="12" :span="24" class="pet__info__item">
                          防曬習慣：<span class="Jost" style="color: #121931">{{ personalityContentMethods('sunProtectionHabits') }}</span>
                        </li>
                        <li :md="12" :span="24" class="pet__info__item">
                          卸妝產品類型：<span class="Jost" style="color: #121931">{{ personalityContentMethods('makeupRemoverType') }}</span>
                        </li>
                        <li :md="12" :span="24" class="pet__info__item">
                          使用的保養品：<span class="Jost" style="color: #121931">{{ personalityContentMethods('skinCareProductsUsed') }}</span>
                        </li>
                        <li :md="12" :span="24" class="pet__info__item">
                          近期醫美療程：<span class="Jost" style="color: #121931">{{ personalityContentMethods('recentMedicalTreatment') }}</span>
                        </li>
                        <li :md="12" :span="24" class="pet__info__item">
                          希望解決的肌膚問題：<span class="Jost" style="color: #121931">{{ personalityContentMethods('skinProblemYouWantToSolve') }}</span>
                        </li>
                      </ul>
                    </div>
                  </el-col>
                </el-row>
                <el-divider v-if="$merchantI18n() === 'pet'"></el-divider>
                <!-- 寵物問題 觀看模式 -->
                <div v-if="$merchantI18n() === 'pet'" class="petQuestion">
                  <h4 class="form-block-title"> {{ $t('reserve.CLIENT') }}問題 </h4>
                  <ul v-if="petDetailInfo.questions" class="pet__info__list">
                    <li class="pet__info__item"
                      >個性：<span class="text-secondary">{{ personalityContent ? personalityContent : '未填寫' }}</span></li
                    >
                    <li class="pet__info__item"
                      >健康狀況：<span class="text-secondary">{{ healthyContent ? healthyContent : '未填寫' }}</span></li
                    >
                    <li class="pet__info__item indentList">
                      <span class="title">行為：</span>
                      <template v-if="behaviorContent.length > 0">
                        <span class="content">
                          <span v-for="n in behaviorContent" :key="n" class="content__item text-secondary">{{ n }}</span>
                        </span>
                      </template>
                      <span v-else><span class="text-secondary">未填寫</span></span>
                    </li>
                    <li class="pet__info__item"
                      >疫苗：<span class="text-secondary">{{ petDetailInfo.questions.vaccine ? vaccineContent : '未填寫' }}</span></li
                    >
                  </ul>
                </div>
                <el-divider></el-divider>
                <div class="notice">
                  <!-- 寵物備註 -->
                  <Note
                    ref="note"
                    :default-value="petDetailInfo"
                    type="pet"
                    :is-employee="isEmployee"
                    is-can-add
                    is-order
                    @update="updatePetList"
                    @edit="isEditPetComment"
                    @item="setPetCommentData"
                  ></Note>
                  <!-- <div> {{ petDetailInfo.PetComment }}</div> -->
                </div>
              </div>
            </div>
            <!-- 歷史紀錄 -->
            <PetCommentList v-if="petDetailInfo.id && petActiveTab === 'service'" ref="commentAll" :order="undefined" :pet="petDetailInfo.id" type="pet"
              @loading-change="onCommentLoadingChange" />
            <PetCommentList v-if="defaultValue && petActiveTab === 'currentService'" ref="commentAll2" :order="defaultValue" type="order"
              @loading-change="onCommentLoadingChange" />
          </template>
        </div>
      </template>
    </template>
    <el-dialog :visible.sync="dialogVisible" width="1135px" top="0" append-to-body>
      <img width="100%" :src="dialogImageUrl" />
    </el-dialog>
  </div>
</template>
<style lang="scss" module>

.orderformSection {
  :global {
    .orderformSection {
      &__right {
        position: relative;
        width: 43%;
        height: calc(100vh);
        overflow: hidden;

        .orderformSection__right__header {
          background-color: $color-line;
          z-index: 999;
        }

        &__title {
          margin: 0;
          padding: 19px 0;
          padding-left: 50px;
        }

        &__header {
          position: relative;
          border-bottom: $color-border-base 1px solid;

          .el-drawer__close-btn {
            // font-weight: 300;
            color: #72767b;
            position: absolute;
            padding: 15px;
            border: 0;
            left: 0;
            top: 3px;
          }

          .el-tabs__item {
            height: auto;
            padding: 10px 0;
          }

          .el-tabs__nav-wrap::after {
            display: none;
          }

          .el-tabs__header {
            margin-bottom: 0;
          }

          .el-tabs--top {
            margin-left: 60px;

            @include max-lg {
              margin-left: 30px;
            }
          }
        }

        &__content {
          z-index: 10;
          height: calc(100vh - 60px);
          overflow-y: auto;
          padding: 30px;
          padding-bottom: 120px;
          position: relative;
          background-color: $color-line;

          @include max-lg {
            padding: 20px;
            padding-bottom: 120px;
          }

          @include max-md {
            padding: 20px;
            padding-bottom: 120px;
          }
        }
      }
    }

    .client {
      padding-left: 10px;
      padding-right: 10px;
    }

    .el-upload {
      &__img {
        width: 140px;
        height: 140px;
        background-color: #eee;
        background-position: center;
        background-size: cover;
        border-radius: 100%;
        opacity: 1;
        transition: opacity 0.3s;
        position: relative;
        border-radius: 50%;
        margin: 0 auto;
      }
    }
  }
}

:global {
  .el-form {
    &.isStylePetList {
      .el-form-item__label {
        float: inherit;
      }

      .btn-group-inline {
        @include max-sm {
          &.isStylePetList {
            margin-top: 40px;
          }
        }
      }
    }
  }
}

// 寵物
.petListImg {
  border-radius: 10px;
  overflow: hidden;
  height: 70px;
}

.pet {
  // font-size: 18px;
  :global {
    .danger {
      color: $color-state-danger;
    }

    .top {
      margin-bottom: 20px;
      display: flex;
      justify-content: space-between;
    }

    .pet {
      &__back {
        cursor: pointer;
      }

      &__box {
        margin-bottom: 30px;
      }

      &__info {
        &__list {
        }

        &__item {
          margin-bottom: 18px;
        }
      }
    }

    .notice,
    .petQuestion {
      margin-bottom: 30px;

      h5 {
        font-size: 18px;
      }

      line-height: 1.5;
    }
  }
}

.petList {
  display: flex;
  align-items: center;
  border: $color-border-base 1px solid;
  background: #fff;
  border-radius: 7px;
  padding: 15px;
  margin-bottom: 10px;
  cursor: pointer;

  &:global {
    &.isActive {
      border-color: $color-primary;
      box-shadow: inset 0 0 0 2px $color-primary;
    }
  }

  // justify-content: space-between;
  :global {
    .petList {
      &__img {
        width: 80px;
        border: 0;
        height: 80px;
        display: block;
        background: #bbb;
        margin-right: 20px;
        min-width: 80px;
        border-radius: 50%;
        overflow: hidden;
      }

      &__cont {
        width: calc(100% - 100px);
      }

      &__btn {
        background-color: #eff9fb;
        cursor: pointer;
        padding: 12px;
        border-radius: 7px;
      }
    }
  }
}
</style>
